import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Shirditoashtavinayakdarshan() {



    const cardData = {





keyword: "Shirdi to Ashtavinayak Darshan Package",

headingDescription: "Sai Shirdi Cab offers a convenient Shirdi to Ashtavinayak Darshan Package for devotees, families, senior citizens, and groups who want to visit the revered Ashtavinayak temples across Maharashtra from Shirdi. The package can be arranged with comfortable chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, and other suitable vehicles based on passenger count and travel requirements. Customers can plan a multi-day pilgrimage covering the important Ashtavinayak temples with flexible pickup and drop arrangements, comfortable seating, sufficient luggage space, and an itinerary designed around darshan and travel preferences. With experienced drivers and private transportation throughout the journey, Sai Shirdi Cab makes it easier for devotees to travel between the different temple destinations without changing vehicles or depending on multiple public transport services.",

topPlaces: [
  {
    title: "Morgaon – Mayureshwar Temple",
    description: "Morgaon is home to the Mayureshwar Temple, traditionally regarded as the first temple to be visited in the Ashtavinayak pilgrimage sequence. The temple is located in the Pune district and is an important destination for devotees undertaking the complete Ashtavinayak circuit. Travelers from Shirdi can include Morgaon in a customized private cab itinerary with comfortable travel between each pilgrimage stop."
  },
  {
    title: "Siddhatek – Siddhivinayak Temple",
    description: "Siddhatek is known for the Siddhivinayak Temple, one of the revered Ashtavinayak shrines dedicated to Lord Ganesha. Its peaceful surroundings make it an important stop during the traditional pilgrimage circuit. Sai Shirdi Cab provides private transportation so devotees can travel comfortably from one temple to another according to their planned darshan schedule."
  },
  {
    title: "Theur – Chintamani Temple",
    description: "Theur is famous for the Chintamani Temple and is an important pilgrimage destination near Pune. Devotees visiting the Ashtavinayak circuit can include Theur as part of their multi-temple journey. Families and senior citizens can choose comfortable vehicles with flexible travel timings, allowing them to manage temple visits without rushing between destinations."
  },
  {
    title: "Ranjangaon – Mahaganapati Temple",
    description: "Ranjangaon is home to the Mahaganapati Temple and is an important stop on the Ashtavinayak pilgrimage route. The temple attracts devotees from different parts of Maharashtra throughout the year. Travelers starting their pilgrimage from Shirdi can arrange a private cab package that includes Ranjangaon along with the other major Ashtavinayak destinations."
  },
  {
    title: "Lenyadri – Girijatmaj Temple",
    description: "Lenyadri is known for the Girijatmaj Temple, situated among a group of rock-cut caves and reached through a series of steps. The combination of religious importance and natural surroundings makes it a distinctive stop in the Ashtavinayak circuit. A private chauffeur-driven cab allows devotees to reach the destination comfortably and continue their pilgrimage at their own pace."
  },
  {
    title: "Ozar – Vighneshwar Temple",
    description: "Ozar is home to the Vighneshwar Temple, a significant Ashtavinayak shrine known for its traditional temple architecture and spiritual atmosphere. Devotees can include Ozar in their customized pilgrimage package while traveling through the Pune region. Sai Shirdi Cab provides convenient intercity transportation for families and groups completing multiple temple visits."
  },
  {
    title: "Pali – Ballaleshwar Temple",
    description: "Pali is the location of the Ballaleshwar Temple, one of the eight important Ashtavinayak shrines of Lord Ganesha. The temple is an essential stop for devotees completing the traditional circuit. Customers can travel in a private cab with flexible sightseeing and darshan timings, making the multi-day pilgrimage more comfortable for families and senior citizens."
  },
  {
    title: "Mahad – Varadvinayak Temple",
    description: "Mahad is known for the Varadvinayak Temple and is another important destination included in the Ashtavinayak pilgrimage. Devotees can conveniently add Mahad to their itinerary while traveling between the temple locations across Maharashtra. Comfortable private cabs provide door-to-door transportation and practical luggage space throughout the pilgrimage."
  },
  {
    title: "Pune",
    description: "Pune serves as an important travel hub for several Ashtavinayak temple locations and can be included in the itinerary for accommodation, rest, or onward travel. Customers starting from Shirdi can plan their pilgrimage around Pune and nearby temple destinations. Sai Shirdi Cab offers spacious vehicles and flexible multi-day arrangements for families and groups."
  }
],




"services": [
  {
    "name": "Shirdi to Ashtavinayak Darshan Cab",
    "description": "Shirdi to Ashtavinayak Darshan Cab provides private transportation for devotees planning to visit the Ashtavinayak temples from Shirdi. Suitable vehicles can be arranged for families, senior citizens, groups, and customized pilgrimage itineraries."
  },
  {
    "name": "Shirdi to Ashtavinayak Darshan Taxi",
    "description": "Shirdi to Ashtavinayak Darshan Taxi offers convenient transportation for travelers visiting the eight revered Ganpati temples across Maharashtra. Sedan, Ertiga, Innova, SUV, and larger vehicles can be selected according to group size and travel needs."
  },
  {
    "name": "Ashtavinayak Shirdi Shani Shingnapur Tour Package",
    "description": "Ashtavinayak Shirdi Shani Shingnapur Tour Package combines important pilgrimage destinations in one customized journey. Private cab arrangements can cover temple visits, intercity transfers, overnight stays, and return travel according to the selected itinerary."
  },
  {
    "name": "Shirdi to Ranjangaon Ganpati Darshan Booking",
    "description": "Shirdi to Ranjangaon Ganpati Darshan Booking provides private transportation for devotees visiting Mahaganapati Temple at Ranjangaon. The journey can be planned as part of an Ashtavinayak yatra, family pilgrimage, or customized Maharashtra temple tour."
  },
  {
    "name": "Shirdi to Siddhatek Ganpati Darshan Cab",
    "description": "Shirdi to Siddhatek Ganpati Darshan Cab offers comfortable transportation for devotees traveling to Siddhatek for Ganpati darshan. Cabs can be arranged for direct journeys, multi-temple pilgrimages, family groups, and customized return trips."
  },
  {
    "name": "Shirdi to Ashtavinayak Darshan Cab Booking Online",
    "description": "Shirdi to Ashtavinayak Darshan Cab Booking Online allows devotees to arrange their pilgrimage transportation in advance. Vehicle selection can be planned according to passenger count, luggage, travel dates, temple sequence, and preferred tour duration."
  },
  {
    "name": "Shirdi to Ballaleshwar Pali Ganpati Darshan",
    "description": "Shirdi to Ballaleshwar Pali Ganpati Darshan provides private cab transportation for devotees visiting the Ballaleshwar Temple at Pali. The journey can be included in a complete Ashtavinayak itinerary or arranged as an individual temple transfer."
  },
  {
    "name": "Shirdi to Siddhivinayak Temple Ganpati Darshan",
    "description": "Shirdi to Siddhivinayak Temple Ganpati Darshan offers convenient transportation for travelers planning a Ganpati temple visit. Private cars can be arranged for families, devotees, groups, and customized pilgrimage routes covering multiple religious destinations."
  },
  {
    "name": "Shirdi to Varad Vinayak Temple Mahad Darshan",
    "description": "Shirdi to Varad Vinayak Temple Mahad Darshan provides comfortable private transportation to Mahad for devotees visiting Varad Vinayak Temple. The cab service can be combined with other Ashtavinayak temples for a multi-day pilgrimage tour."
  },
  {
    "name": "Shirdi to Vigneshwar Ozar Ganpati Darshan",
    "description": "Shirdi to Vigneshwar Ozar Ganpati Darshan offers private travel arrangements for devotees visiting Vigneshwar Temple at Ozar. Suitable vehicles can be selected for individual travelers, families, senior citizens, and groups undertaking an Ashtavinayak yatra."
  },
  {
    "name": "Shirdi to Chintamani Theur Ganpati Darshan",
    "description": "Shirdi to Chintamani Theur Ganpati Darshan provides convenient cab transportation to Theur for devotees seeking Ganpati darshan. The service can be arranged as a dedicated temple trip or included within a broader Ashtavinayak pilgrimage itinerary."
  },
  {
    "name": "Shirdi to Lenyadri Ashtavinayak Darshan Cab",
    "description": "Shirdi to Lenyadri Ashtavinayak Darshan Cab helps devotees travel comfortably to Lenyadri for Girijatmaj Ganpati darshan. Private transportation can be arranged for families and groups along with other Ashtavinayak temple visits."
  },
  {
    "name": "Ashtavinayak Darshan Tempo Traveller on Rent",
    "description": "Ashtavinayak Darshan Tempo Traveller on Rent is suitable for larger families, friends, pilgrimage groups, and organized tours. Spacious traveller vehicles can support multi-temple journeys with comfortable seating and sufficient luggage capacity."
  },
  {
    "name": "Shirdi to Ashtavinayak Darshan Package",
    "description": "Shirdi to Ashtavinayak Darshan Package provides private transportation for devotees planning to cover the important Ganpati temples from Shirdi. The itinerary can be customized according to temple sequence, travel duration, group size, and stay requirements."
  },
  {
    "name": "Shirdi to Ashtavinayak Cab",
    "description": "Shirdi to Ashtavinayak Cab offers private transportation for travelers planning a complete or partial Ashtavinayak pilgrimage. Sedan, Ertiga, Innova, SUV, and larger group vehicles can be arranged for different travel requirements."
  },
  {
    "name": "Shirdi to Ashtavinayak Darshan Cab",
    "description": "Shirdi to Ashtavinayak Darshan Cab is suitable for devotees seeking comfortable transportation between Shirdi and the Ashtavinayak temples. The service can support one-day, two-day, three-day, and customized pilgrimage schedules."
  },
  {
    "name": "Shirdi to Ashtavinayak Taxi",
    "description": "Shirdi to Ashtavinayak Taxi provides convenient private travel for pilgrims visiting multiple Ganpati temples in Maharashtra. Travelers can choose a suitable vehicle based on the number of passengers, luggage, journey duration, and comfort preferences."
  },
  {
    "name": "Shirdi Ashtavinayak Tour Package",
    "description": "Shirdi Ashtavinayak Tour Package is designed for devotees who want to combine a visit to Shirdi with an Ashtavinayak temple pilgrimage. Private cab arrangements can be customized for temple visits, overnight stays, sightseeing, and return transportation."
  },
  {
    "name": "Ashtavinayak Darshan Package from Shirdi",
    "description": "Ashtavinayak Darshan Package from Shirdi provides a flexible pilgrimage travel option covering selected or all eight Ganpati temples. Families, senior citizens, couples, and groups can choose vehicle and itinerary options according to their travel plans."
  },
  {
    "name": "Ashtavinayak Cab Service from Shirdi",
    "description": "Ashtavinayak Cab Service from Shirdi offers private transportation for devotees traveling across Maharashtra for Ganpati temple darshan. The service can accommodate short temple trips as well as extended multi-day pilgrimage journeys."
  },
  {
    "name": "Shirdi to Ashtavinayak Yatra",
    "description": "Shirdi to Ashtavinayak Yatra provides a planned private travel option for devotees visiting the sacred Ganpati temples. The route can be organized around the preferred temple sequence, travel duration, accommodation plans, and group requirements."
  },
  {
    "name": "Shirdi Ashtavinayak Darshan by Car",
    "description": "Shirdi Ashtavinayak Darshan by Car provides a comfortable private journey for families and small groups. Air-conditioned cars can be arranged for temple transfers, sightseeing, overnight travel, and customized Ashtavinayak pilgrimage routes."
  },
  {
    "name": "Shirdi to Eight Ganpati Darshan",
    "description": "Shirdi to Eight Ganpati Darshan offers private transportation for devotees planning to visit all eight Ashtavinayak temples. The journey can be structured over multiple days to provide a practical schedule for temple visits and rest stops."
  },
  {
    "name": "Shirdi Ashtavinayak Pilgrimage Package",
    "description": "Shirdi Ashtavinayak Pilgrimage Package combines Shirdi travel with an organized Ashtavinayak temple journey. Private vehicles can be arranged for families, senior citizens, groups, and devotees seeking a customized pilgrimage experience."
  },
  {
    "name": "Ashtavinayak Temple Tour from Shirdi",
    "description": "Ashtavinayak Temple Tour from Shirdi provides convenient cab transportation for devotees visiting the renowned Ganpati temples of Maharashtra. Tour duration and vehicle category can be selected according to the planned itinerary and passenger requirements."
  },
  {
    "name": "Shirdi to Ashtavinayak Two-Day Package",
    "description": "Shirdi to Ashtavinayak Two-Day Package is suitable for devotees looking to cover multiple Ganpati temples within a compact pilgrimage schedule. Private cab arrangements can be planned around temple timings, overnight stays, and return travel."
  },
  {
    "name": "Shirdi Ashtavinayak 2 Days 1 Night Package",
    "description": "Shirdi Ashtavinayak 2 Days 1 Night Package provides a short pilgrimage itinerary combining Shirdi and selected Ashtavinayak temples. Comfortable private vehicles can be arranged for families and groups according to the preferred temple route."
  },
  {
    "name": "Shirdi to Ashtavinayak Three-Day Package",
    "description": "Shirdi to Ashtavinayak Three-Day Package provides additional travel time for devotees planning a more relaxed temple journey. The itinerary can include multiple Ashtavinayak destinations with suitable breaks, overnight stays, and private cab transportation."
  },
  {
    "name": "Shirdi Ashtavinayak 3 Days 2 Nights Package",
    "description": "Shirdi Ashtavinayak 3 Days 2 Nights Package is suitable for pilgrims who prefer a comfortable multi-day itinerary. The journey can be customized for temple darshan, overnight accommodation planning, sightseeing, family travel, and return transportation."
  },
  {
    "name": "Shirdi Ashtavinayak One-Day Tour",
    "description": "Shirdi Ashtavinayak One-Day Tour provides private cab transportation for travelers planning a compact temple visit. The route can be customized according to the available time, selected temples, passenger requirements, and preferred vehicle category."
  },
  {
    "name": "Shirdi Ashtavinayak Weekend Package",
    "description": "Shirdi Ashtavinayak Weekend Package offers a convenient option for devotees planning their pilgrimage during a weekend. Private cars and group vehicles can be arranged for temple visits, overnight stays, and return travel within the planned schedule."
  },
  {
    "name": "Two-Day Ashtavinayak Darshan from Shirdi",
    "description": "Two-Day Ashtavinayak Darshan from Shirdi provides a structured private travel option for pilgrims who want to cover several Ganpati temples within two days. The route can be adjusted according to temple preferences and group requirements."
  },
  {
    "name": "Three-Day Ashtavinayak Yatra from Shirdi",
    "description": "Three-Day Ashtavinayak Yatra from Shirdi allows devotees to plan a more relaxed multi-day pilgrimage across the Ashtavinayak temples. Comfortable cab and traveller options can be arranged for families, senior citizens, and larger groups."
  },
  {
    "name": "Shirdi Ashtavinayak Multi-Day Cab",
    "description": "Shirdi Ashtavinayak Multi-Day Cab provides private transportation for extended pilgrimage journeys covering multiple Ganpati temples. Vehicle selection and travel schedules can be customized according to passenger count, luggage, overnight stays, and temple preferences."
  },
  {
    "name": "Shirdi Ashtavinayak Overnight Tour",
    "description": "Shirdi Ashtavinayak Overnight Tour provides convenient transportation for devotees who want to continue their temple journey beyond a single day. Private cab arrangements can include multiple destinations, overnight travel plans, and return transfers."
  },
  {
    "name": "Shirdi Ashtavinayak Complete Darshan Package",
    "description": "Shirdi Ashtavinayak Complete Darshan Package is designed for devotees planning an extensive pilgrimage covering the Ashtavinayak temples from Shirdi. The trip can be customized with private vehicles, multiple overnight stops, and a practical temple-wise itinerary."
  },
  {
    "name": "Shirdi to All Eight Ganpati Temples Package",
    "description": "Shirdi to All Eight Ganpati Temples Package provides private transportation for devotees planning to visit the complete Ashtavinayak circuit. Cars and larger group vehicles can be arranged according to passenger numbers and the preferred number of travel days."
  },
  {
    "name": "Shirdi to Mayureshwar Morgaon Cab",
    "description": "Shirdi to Mayureshwar Morgaon Cab offers convenient private transportation to Morgaon for devotees visiting the Mayureshwar Ganpati Temple. The journey can be booked independently or included as part of a complete Ashtavinayak tour."
  },
  {
    "name": "Shirdi to Siddhivinayak Siddhatek Cab",
    "description": "Shirdi to Siddhivinayak Siddhatek Cab provides private travel for devotees visiting Siddhatek during their Ashtavinayak pilgrimage. Comfortable vehicle options can be selected for families, couples, senior citizens, and group travelers."
  },
  {
    "name": "Shirdi to Ballaleshwar Pali Cab",
    "description": "Shirdi to Ballaleshwar Pali Cab provides convenient transportation to Pali for Ganpati darshan. The cab can be arranged as a dedicated temple transfer or combined with other Ashtavinayak destinations for a multi-day pilgrimage."
  },
  {
    "name": "Shirdi to Varadvinayak Mahad Cab",
    "description": "Shirdi to Varadvinayak Mahad Cab offers private transportation for devotees visiting Varad Vinayak Temple at Mahad. The journey can be combined with nearby Ashtavinayak temples and customized according to the preferred pilgrimage schedule."
  }
],
"tableData": [
  ["Shirdi to Ashtavinayak Darshan Cab", "Shirdi to Ashtavinayak Darshan Taxi"],
  ["Ashtavinayak Shirdi Shani Shingnapur Tour Package", "Shirdi to Ranjangaon Ganpati Darshan Booking"],
  ["Shirdi to Siddhatek Ganpati Darshan Cab", "Shirdi to Ashtavinayak Darshan Cab Booking Online"],
  ["Shirdi to Ballaleshwar Pali Ganpati Darshan", "Shirdi to Siddhivinayak Temple Ganpati Darshan"],
  ["Shirdi to Varad Vinayak Temple Mahad Darshan", "Shirdi to Vigneshwar Ozar Ganpati Darshan"],
  ["Shirdi to Chintamani Theur Ganpati Darshan", "Shirdi to Lenyadri Ashtavinayak Darshan Cab"],
  ["Ashtavinayak Darshan Tempo Traveller on Rent", "Shirdi to Ashtavinayak Darshan Package"],
  ["Shirdi to Ashtavinayak Cab", "Shirdi to Ashtavinayak Taxi"],
  ["Shirdi Ashtavinayak Tour Package", "Ashtavinayak Darshan Package from Shirdi"],
  ["Ashtavinayak Cab Service from Shirdi", "Shirdi to Ashtavinayak Yatra"],
  ["Shirdi Ashtavinayak Darshan by Car", "Shirdi to Eight Ganpati Darshan"],
  ["Shirdi Ashtavinayak Pilgrimage Package", "Ashtavinayak Temple Tour from Shirdi"],
  ["Shirdi to Ashtavinayak Two-Day Package", "Shirdi Ashtavinayak 2 Days 1 Night Package"],
  ["Shirdi to Ashtavinayak Three-Day Package", "Shirdi Ashtavinayak 3 Days 2 Nights Package"],
  ["Shirdi Ashtavinayak One-Day Tour", "Shirdi Ashtavinayak Weekend Package"],
  ["Two-Day Ashtavinayak Darshan from Shirdi", "Three-Day Ashtavinayak Yatra from Shirdi"],
  ["Shirdi Ashtavinayak Multi-Day Cab", "Shirdi Ashtavinayak Overnight Tour"],
  ["Shirdi Ashtavinayak Complete Darshan Package", "Shirdi to All Eight Ganpati Temples Package"],
  ["Shirdi to Mayureshwar Morgaon Cab", "Shirdi to Siddhivinayak Siddhatek Cab"],
  ["Shirdi to Ballaleshwar Pali Cab", "Shirdi to Varadvinayak Mahad Cab"]
],


        whychoose: [
            { 
                WhyChooseheading: "Complete Shirdi to Ashtavinayak Darshan Package", 
                WhyChoosedescription: "Sai Shirdi Cabs offers a convenient private cab option for devotees planning an Ashtavinayak pilgrimage from Shirdi. The journey is suitable for families, senior citizens, religious groups, and travellers who want to visit the important Ganpati temples with a planned and comfortable travel arrangement." 
            }, 
            { 
                WhyChooseheading: "Convenient Start from Shirdi", 
                WhyChoosedescription: "Begin your pilgrimage directly from your Shirdi hotel, residence, railway station area, or another preferred pickup location. Starting with a dedicated vehicle makes it easier to organize the long religious journey without depending on different transport services." 
            }, 
            { 
                WhyChooseheading: "Visit the Eight Ashtavinayak Temples", 
                WhyChoosedescription: "Plan a dedicated pilgrimage covering the eight traditionally revered Ashtavinayak temples of Maharashtra. The itinerary can be discussed according to your available days, preferred route, temple timings, and group travel requirements." 
            }, 
            { 
                WhyChooseheading: "Comfortable Travel for Pilgrimage Groups", 
                WhyChoosedescription: "Families and groups can select a suitable vehicle according to the number of devotees, luggage, and desired comfort level. Travelling together in one cab helps keep the pilgrimage organized throughout the multiple temple visits." 
            }, 
            { 
                WhyChooseheading: "Flexible Multi-Day Travel Plan", 
                WhyChoosedescription: "An Ashtavinayak pilgrimage may require multiple days depending on the selected route and sightseeing preferences. Your cab plan can be discussed around your schedule so the journey is arranged according to your intended travel duration." 
            }, 
            { 
                WhyChooseheading: "Temple-to-Temple Private Transportation", 
                WhyChoosedescription: "A dedicated cab provides direct transportation between pilgrimage destinations, allowing devotees to keep their luggage with them and avoid repeatedly arranging local transportation between different temple locations." 
            }, 
            { 
                WhyChooseheading: "Suitable for Senior Citizens & Families", 
                WhyChoosedescription: "Devotees travelling with parents, senior citizens, children, or family members can choose a comfortable vehicle and plan suitable breaks during the journey. Private transportation provides more flexibility for a family pilgrimage." 
            }, 
            { 
                WhyChooseheading: "Book Shirdi to Ashtavinayak Darshan Package with Sai Shirdi Cabs", 
                WhyChoosedescription: "Share your preferred travel dates, number of devotees, luggage details, desired vehicle, pilgrimage duration, and itinerary requirements with Sai Shirdi Cabs to plan your Shirdi to Ashtavinayak Darshan Package." 
            } 
        ] 
 
    }; 
 
    const faqData = [ 
        { 
            question: "Can I book a Shirdi to Ashtavinayak Darshan Package?", 
            answer: "Yes, Sai Shirdi Cabs provides private cab arrangements for devotees planning an Ashtavinayak pilgrimage from Shirdi, including families, senior citizens, and religious groups." 
        }, 
        { 
            question: "Does the package cover all eight Ashtavinayak temples?", 
            answer: "The itinerary can be planned to cover the eight traditionally recognized Ashtavinayak temples. The exact route and duration can be discussed according to your travel schedule." 
        }, 
        { 
            question: "How many days are required for an Ashtavinayak Darshan trip?", 
            answer: "The number of days depends on the chosen route, temple timings, starting point, sightseeing plans, and available travel time. A customized itinerary can be planned based on your requirements." 
        }, 
        { 
            question: "Can families book an Ashtavinayak cab from Shirdi?", 
            answer: "Yes, families can arrange a private cab according to their passenger count, luggage requirements, preferred vehicle, and planned pilgrimage duration." 
        }, 
        { 
            question: "Is the Ashtavinayak package suitable for senior citizens?", 
            answer: "Yes, private cab travel can be convenient for devotees travelling with senior citizens because the family can remain together and plan breaks according to their needs." 
        }, 
        { 
            question: "Can I customize the Shirdi to Ashtavinayak itinerary?", 
            answer: "Yes, the itinerary can be discussed according to your preferred travel dates, temple sequence, sightseeing requirements, number of passengers, and overall pilgrimage schedule." 
        }, 
        { 
            question: "Which vehicles are available for the Ashtavinayak trip?", 
            answer: "Vehicle selection depends on the number of devotees, luggage, journey duration, and comfort requirements. Suitable car and larger group vehicle options can be discussed during booking." 
        }, 
        { 
            question: "Can I carry luggage during the Ashtavinayak Darshan trip?", 
            answer: "Yes, passengers can carry their personal luggage throughout the pilgrimage according to the capacity of the selected vehicle. Additional baggage should be mentioned while planning the booking." 
        }, 
        { 
            question: "Can I start the Ashtavinayak trip from my Shirdi hotel?", 
            answer: "Yes, pickup can be arranged from your Shirdi hotel, residence, railway station area, or another convenient location before starting the Ashtavinayak pilgrimage." 
        }, 
        { 
            question: "How can I book Shirdi to Ashtavinayak Darshan Package with Sai Shirdi Cabs?", 
            answer: "Share your travel dates, Shirdi pickup location, passenger count, preferred vehicle, luggage details, expected trip duration, and itinerary requirements with Sai Shirdi Cabs to arrange the pilgrimage package." 
        } 
    ]; 
 
    const testimonials = [ 
        { 
            id: 1, 
            name: "Mr. Mahesh Pawar", 
            feedback: "We planned an Ashtavinayak pilgrimage after our Shirdi visit with our entire family. Having one private cab throughout the trip made the multiple temple visits easier to coordinate and much more comfortable.", 
            rating: 5 
        }, 
        { 
            id: 2, 
            name: "Mrs. Sunita Kulkarni", 
            feedback: "Our group included senior family members, so we wanted private transportation for the pilgrimage. The dedicated cab allowed us to travel together, keep our luggage with us, and follow our planned temple itinerary.", 
            rating: 5 
        } 
    ];












    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shirdi to Ashtavinayak Darshan Package",
  "image": "https://www.saishirdicabs.com/assets/images/shirdi-to-ashtavinayak-darshan-package.webp",
  "description":
    "Book Shirdi to Ashtavinayak Darshan Package with Sai Shirdi Cabs for a comfortable and convenient pilgrimage journey. We provide customized taxi packages from Shirdi covering Ashtavinayak temples, Ranjangaon Ganpati, Siddhatek Ganpati, and Shani Shingnapur with Sedan, Ertiga, SUV, Innova, Innova Crysta, and Tempo Traveller options. Our cabs are suitable for families, senior citizens, groups, and devotees looking for flexible multi-temple darshan tours.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/shirdi-to-ashtavinayak-darshan-package"
  }
};




    return (
        <div>

<Helmet>
  <title>Shirdi to Ashtavinayak Darshan Package | Cab Booking | +91 7776814559</title>

  <meta
    name="description"
    content="Book Shirdi to Ashtavinayak Darshan Package with Sai Shirdi Cabs for comfortable pilgrimage travel. Get reliable cabs from Shirdi for Ashtavinayak temple visits, Ranjangaon Ganpati, Siddhatek Ganpati, and Shani Shingnapur tours with Sedan, Ertiga, SUV, Innova, Innova Crysta, and Tempo Traveller options."
  />

  <meta
    name="keywords"
    content="shirdi to ashtavinayak darshan cab, shirdi to ashtavinayak darshan taxi, Ashtavinayak Shirdi Shani Shingnapur Tour Package, shirdi to ranjangaon ganpati darshan booking, shirdi to siddhatek ganpati darshan cab, shirdi to ashtavinayak, Shirdi to Ashtavinayak Darshan Package, Shirdi Ashtavinayak Taxi Service, Shirdi Ashtavinayak Cab Booking, Shirdi to Ashtavinayak One Way Cab, Shirdi to Ashtavinayak Round Trip Taxi, Shirdi to Ranjangaon Ganpati Taxi, Shirdi to Siddhatek Ganpati Cab, Shirdi to Shani Shingnapur Tour Package, Ashtavinayak Temple Tour from Shirdi, Ashtavinayak Darshan Car Rental, Ashtavinayak Tempo Traveller from Shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/8.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Shirditoashtavinayakdarshan;